
export const getInitials = (name: string | null | undefined) => {
  if (!name || typeof name !== 'string' || name.trim() === '') {
    return 'U';
  }
  
  const trimmedName = name.trim();
  const parts = trimmedName.split(' ').filter(part => part.length > 0);
  
  if (parts.length === 0) {
    return 'U';
  }
  
  const initials = parts
    .map(part => part[0])
    .join('')
    .toUpperCase()
    .substring(0, 2);
    
  return initials;
};

export const capitalizeFullName = (name: string | null | undefined) => {
  if (!name || typeof name !== 'string') return '';
  return name
    .split(' ')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
};
